import {Typography, PaperProps} from '@mui/material';
import Paper from '@mui/material/Paper';
import React from 'react';
import classNames from 'classnames';
import {usePanelStyles} from './Panel.styles';

type PanelProps = {
   root?: boolean;
   name?: string;
   className?: string;
   style?: React.CSSProperties;
   children: React.ReactNode;
   marginTop?: number;
   elevetion?: PaperProps['elevation'];
};

const Panel = ({root, name, className, children, style, marginTop, elevetion = 2}: PanelProps) => {
   const classes = usePanelStyles({marginTop});
   return (
      <Paper
         className={classNames(classes.root, className, {[classes.rootPanel]: root})}
         style={style}
         elevation={elevetion}
      >
         {name ? (
            <div className={classes.header}>
               <Typography color="primary" variant={'inherit'} className={classNames(classes.name)}>
                  {name}
               </Typography>
            </div>
         ) : null}
         {children}
      </Paper>
   );
};

export default Panel;
